import {
  afterNextRender,
  Directive,
  ElementRef,
  input,
  model,
  output,
} from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';

@Directive({
  selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective {
  hasNext = input<boolean>(false);
  next = output<void>();

  type = model<'window' | 'element' | 'layout'>('window');

  constructor(private readonly el: ElementRef) {
    afterNextRender(() => {
      if (this.type() === 'window') {
        fromEvent(window, 'scroll')
          .pipe(debounceTime(300))
          .subscribe(() => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const threshold = document.body.offsetHeight - 100;
            if (scrollPosition > threshold) {
              if (this.hasNext() && this.next) {
                this.next.emit();
              }
            }
          });
        return;
      } else if (this.type() === 'element') {
        fromEvent(this.el.nativeElement, 'scroll')
          .pipe(debounceTime(300))
          .subscribe(() => {
            const scrollPosition =
              this.el.nativeElement.scrollTop +
              this.el.nativeElement.clientHeight;
            const threshold = this.el.nativeElement.scrollHeight - 100;

            if (scrollPosition > threshold) {
              if (this.hasNext() && this.next) {
                this.next.emit();
              }
            }
          });
      } else if (this.type() === 'layout') {
        const layout = document.getElementById('layout-content');

        if (layout) {
          fromEvent(layout, 'scroll')
            .pipe(debounceTime(300))
            .subscribe(() => {
              const scrollPosition = layout.scrollTop + layout.clientHeight;
              const threshold = layout.scrollHeight - 100;

              if (scrollPosition > threshold) {
                if (this.hasNext() && this.next) {
                  this.next.emit();
                }
              }
            });
        }
      }
    });
  }
}
